import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const OBSERVATION_CONSEQUENCE = {
	name: "OBSERVATION_CONSEQUENCE",
	concept: {
		ANXIETY: {
			display: {
				"nl-BE": "Angst",
				"fr-BE": "Anxiété",
			},
		},
		BLEEDING: {
			display: {
				"nl-BE": "Bloeding",
				"fr-BE": "Saignement",
			},
		},
		BRUISES: {
			display: {
				"nl-BE": "Kneuzing",
				"fr-BE": "Contusion",
			},
		},
		LEGACY_CONCUSSION: {
			display: {
				"nl-BE": "Hersenschudding",
				"fr-BE": "Commotion cérébrale",
			},
		},
		CONFUSION: {
			display: {
				"nl-BE": "Verwardheid",
				"fr-BE": "Confusion",
			},
		},
		LEGACY_DEATH: {
			display: {
				"nl-BE": "Overlijden",
				"fr-BE": "Décès",
			},
		},
		DISORIENTATION: {
			display: {
				"nl-BE": "Desoriëntatie",
				"fr-BE": "Désorientation",
			},
		},
		FRACTURE: {
			display: {
				"nl-BE": "Breuk",
				"fr-BE": "Fracture",
			},
		},
		LEGACY_HOSPITALIZATION_MAX_ONE_DAY: {
			display: {
				"nl-BE": "Ziekenhuisopname max 1 dag",
				"fr-BE": "Hospitalisation max 1 jour",
			},
		},
		LEGACY_HOSPITALIZATION_MORE_THAN_ONE_DAY: {
			display: {
				"nl-BE": "Ziekenhuisopname meer dan 1 dag",
				"fr-BE": "Hospitalisation plus d'un jour",
			},
		},
		LOSS_OF_CONSCIOUSNESS: {
			display: {
				"nl-BE": "Bewustzijnsverlies",
				"fr-BE": "Perte de conscience",
			},
		},
		MOBILITY_LIMITATION: {
			display: {
				"nl-BE": "Bewegingsbeperking",
				"fr-BE": "Limitation de mouvement",
			},
		},
		NOSEBLEED: {
			display: {
				"nl-BE": "Bloedneus",
				"fr-BE": "Saignement de nez",
			},
		},
		PAIN: {
			display: {
				"nl-BE": "Pijn",
				"fr-BE": "Douleur",
			},
		},
		SWELLING: {
			display: {
				"nl-BE": "Zwelling",
				"fr-BE": "Gonflement",
			},
		},
		WOUND: {
			display: {
				"nl-BE": "Wond",
				"fr-BE": "Plaie",
			},
		},
		LEGACY_OTHER: {
			display: {
				"nl-BE": "Andere",
				"fr-BE": "Autre",
			},
		},
		LEGACY_NONE: {
			display: {
				"nl-BE": "Geen",
				"fr-BE": "Aucune",
			},
		},
		SOILED_PROTECTION: {
			display: {
				"nl-BE": "Bescherming doorweekt en/of bevuild",
				"fr-BE": "Protection détrempée et/ou souillée",
			},
		},
		SOILED_UNDERWEAR: {
			display: {
				"nl-BE": "Ondergoed nat en/of bevuild",
				"fr-BE": "Sous-vêtements mouillés et/ou souillés",
			},
		},
		SOILED_CLOTHING: {
			display: {
				"nl-BE": "Kleding nat en/of bevuild",
				"fr-BE": "Vêtements mouillés et/ou souillés",
			},
		},
		SOILED_BED: {
			display: {
				"nl-BE": "Bed nat en/of bevuild",
				"fr-BE": "Lit mouillé et/ou souillé",
			},
		},
		SOILED_CHAIR_AND_FLOOR: {
			display: {
				"nl-BE": "Urine en/of ontlasting op stoel of vloer",
				"fr-BE": "Urine et/ou selles sur la chaise ou le sol",
			},
		},
	},
} as const satisfies CodeSystem;
